import { Link } from 'react-router-dom';

const ServicesGrid = () => {
  const services = [
    {
      id: 1,
      title: 'Schengen Bölgesi C Tipi Vizeler',
      subtitle: 'Turistik, Ticari, Aile Ziyareti',
      description: 'Kısa süreli seyahatler için Schengen C tipi vizelerde başvuru belgelerinin hazırlanması, randevu alınması ve evrakların kontrolünde kapsamlı destek sağlanır.',
      icon: 'ri-earth-line',
      gradient: 'from-navy-900 to-navy-800',
      link: '/hizmetler/schengen-c-tipi-vize',
    },
    {
      id: 2,
      title: 'Schengen Bölgesi D Tipi Vizeler',
      subtitle: 'Uzun Süreli ve Ulusal Vizeler',
      description: 'Uzun süreli ikamet veya eğitim amaçlı vize başvurularında, resmi kurumlarla uyumlu şekilde tüm işlemleri eksiksiz yönetiyoruz.',
      icon: 'ri-briefcase-line',
      gradient: 'from-cream-400 to-cream-300',
      link: '/hizmetler/schengen-d-tipi-vize',
    },
    {
      id: 3,
      title: 'Amerika Vizesi',
      subtitle: 'Turistik ve Ticari',
      description: 'ABD\'ye yapılacak seyahatlerde DS-160 formu hazırlığı, randevu işlemleri ve görüşme öncesi bilgilendirme desteği sunulmaktadır.',
      icon: 'ri-flight-takeoff-line',
      gradient: 'from-navy-800 to-navy-700',
      link: '/hizmetler/amerika-vizesi',
    },
    {
      id: 4,
      title: 'İngiltere Vizesi',
      subtitle: 'Turistik ve İş Vizesi',
      description: 'İngiltere vize başvurularında evrak hazırlığı, dilekçe desteği ve başvuru merkezi yönlendirmesi konusunda profesyonel hizmet veriyoruz.',
      icon: 'ri-map-pin-line',
      gradient: 'from-cream-300 to-cream-200',
      link: '/hizmetler/ingiltere-vizesi',
    },
    {
      id: 5,
      title: 'Oturum Kartı Başvuruları',
      subtitle: 'AB Ülkeleri',
      description: 'Avrupa Birliği ülkeleri başta olmak üzere çeşitli ülkelerde oturum kartı başvuruları ve ilk başvuru işlemlerinde danışmanlık.',
      icon: 'ri-home-line',
      gradient: 'from-navy-700 to-navy-600',
      link: '/hizmetler/oturum-karti',
    },
    {
      id: 6,
      title: 'Göçmenlik ve Aile Birleşimi',
      subtitle: 'Kalıcı İkamet Süreçleri',
      description: 'Aile birleşimi, evlilik ve kalıcı göçmenlik başvurularında gerekli yasal düzenlemelerin tamamlanmasını sağlıyoruz.',
      icon: 'ri-group-line',
      gradient: 'from-cream-200 to-cream-100',
      link: '/hizmetler/aile-birlesmesi',
    },
    {
      id: 7,
      title: 'Kapı Vizeleri',
      subtitle: 'Hızlı İşlem',
      description: 'Belirli ülkeler için havaalanında alınabilen kapı vizeleri konusunda bilgilendirme ve evrak hazırlığı desteği sunuyoruz.',
      icon: 'ri-door-open-line',
      gradient: 'from-navy-900 to-navy-800',
      link: '/hizmetler',
    },
    {
      id: 8,
      title: 'Özel Danışmanlık Hizmetleri',
      subtitle: 'Kişiye Özel Çözümler',
      description: 'Her başvuru, ülke prosedürleri ve başvuru sahibinin profiline göre özel olarak değerlendirilir ve yönetilir.',
      icon: 'ri-user-star-line',
      gradient: 'from-cream-400 to-cream-300',
      link: '/hizmetler',
    },
  ];

  return (
    <section className="relative py-12 md:py-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/aa872610c2b76d7e52b021fb20ca837c.jpg"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/90 to-white/95"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-4 py-1.5 md:px-5 md:py-2 bg-navy-900 text-cream-100 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-5 shadow-lg">
            Hizmetlerimiz
          </span>
          <h2 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-3 md:mb-4">
            İzmir Vize Danışmanlık Hizmetlerimiz
          </h2>
          <p className="text-navy-700 text-sm md:text-lg max-w-3xl mx-auto leading-relaxed">
            Tüm vize türlerinde <strong>profesyonel destek</strong> ve <strong>10+ yıllık deneyimimizle</strong> yanınızdayız
          </p>
        </div>

        {/* Services Grid - Modern Card Design */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-8 md:mb-10">
          {services.map((service) => {
            const isDark = service.gradient.includes('navy');
            return (
              <Link
                key={service.id}
                to={service.link}
                className="group relative overflow-hidden rounded-xl md:rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 cursor-pointer"
              >
                {/* Card Background with Gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient}`}></div>
                
                {/* Decorative Pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute inset-0" style={{
                    backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
                    backgroundSize: '30px 30px'
                  }}></div>
                </div>

                {/* Content */}
                <div className="relative p-4 md:p-6 h-full flex flex-col">
                  {/* Icon */}
                  <div className={`w-10 h-10 md:w-16 md:h-16 flex items-center justify-center ${isDark ? 'bg-cream-400' : 'bg-navy-900'} rounded-lg md:rounded-xl mb-3 md:mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg`}>
                    <i className={`${service.icon} text-xl md:text-3xl ${isDark ? 'text-navy-900' : 'text-cream-100'}`}></i>
                  </div>

                  {/* Title & Subtitle */}
                  <h3 className={`font-display text-sm md:text-xl font-bold ${isDark ? 'text-cream-100' : 'text-navy-900'} mb-1`}>
                    {service.title}
                  </h3>
                  <p className={`text-xs md:text-sm font-semibold ${isDark ? 'text-cream-300' : 'text-navy-700'} mb-2 md:mb-3 uppercase tracking-wide`}>
                    {service.subtitle}
                  </p>

                  {/* Description */}
                  <p className={`${isDark ? 'text-cream-200' : 'text-navy-600'} leading-relaxed mb-3 md:mb-4 flex-grow text-xs md:text-sm line-clamp-3`}>
                    {service.description}
                  </p>

                  {/* CTA Link */}
                  <div className={`inline-flex items-center ${isDark ? 'text-cream-100' : 'text-navy-900'} font-bold group-hover:translate-x-1 transition-transform whitespace-nowrap text-xs md:text-base`}>
                    Detaylı Bilgi
                    <i className="ri-arrow-right-line ml-1 md:ml-2 text-sm md:text-lg"></i>
                  </div>
                </div>

                {/* Hover Effect Border */}
                <div className="absolute inset-0 border-4 border-transparent group-hover:border-navy-900/20 rounded-xl md:rounded-2xl transition-all duration-500"></div>
              </Link>
            );
          })}
        </div>

        {/* E-Vize Section - Enhanced Design */}
        <div className="relative overflow-hidden rounded-xl md:rounded-2xl shadow-2xl">
          <div className="absolute inset-0 bg-gradient-to-r from-navy-900 via-navy-800 to-navy-900"></div>
          
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-cream-400/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-cream-400/10 rounded-full blur-3xl"></div>

          <div className="relative z-10 p-5 md:p-10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
              <div className="flex-1">
                <div className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-cream-400/20 text-cream-100 text-xs font-semibold tracking-widest uppercase rounded-full mb-2 md:mb-3">
                  Hızlı İşlem
                </div>
                <h3 className="font-display text-xl md:text-3xl font-bold text-cream-100 mb-2 md:mb-3">
                  E-Vize Hizmetleri
                </h3>
                <p className="text-cream-300 text-sm md:text-base mb-3 md:mb-4">
                  Dubai, Ermenistan, Kuveyt, Suudi Arabistan, Rusya, Vietnam, Küba
                </p>
                <div className="flex flex-wrap gap-1.5 md:gap-2">
                  {['Dubai', 'Ermenistan', 'Kuveyt', 'Suudi Arabistan', 'Rusya', 'Vietnam', 'Küba'].map((country) => (
                    <span key={country} className="px-2 py-1 md:px-3 md:py-1.5 bg-cream-400/10 text-cream-200 text-xs md:text-sm rounded-full border border-cream-400/20">
                      {country}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-2 md:gap-3 w-full md:w-auto">
                <Link
                  to="/hizmetler/e-vize"
                  className="inline-flex items-center justify-center px-5 py-2.5 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-base hover:bg-cream-300 transition-all hover:scale-105 shadow-xl whitespace-nowrap"
                >
                  Detaylı Bilgi
                  <i className="ri-arrow-right-line ml-2 text-base md:text-lg"></i>
                </Link>
                <a
                  href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-5 py-2.5 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-base hover:bg-green-700 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-lg md:text-xl mr-2"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;